import {cdnUrl} from '@/util/cdnImage';

/**
 * WordPress serves this generic silhouette (`wp-user-avatars` plugin default)
 * when a user has no avatar uploaded — so `author_image` is technically a valid
 * URL but renders as an empty grey placeholder.
 */
const WP_MYSTERY_AVATAR = 'mystery.jpg';

/** Real photos for known blog authors, keyed by their WP display name. */
const AUTHOR_IMAGES: Record<string, string> = {
    'Daljit Singh': cdnUrl('blog/director-daljit-singh.webp'),
    'Gurpreet Singh': cdnUrl('blog/director-gurpreet-singh.webp')
};

/** Shown when the author is unknown and WP has no real avatar. */
const DEFAULT_AUTHOR_IMAGE = cdnUrl('blog/director-daljit-singh.webp');

/**
 * Returns the author's real photo. Falls back from the WP avatar (when it's the
 * mystery.jpg placeholder or missing) to a known-author photo, then the default.
 */
export const resolveAuthorImage = (image?: string, name?: string): string => {
    if (image && !image.includes(WP_MYSTERY_AVATAR)) return image;
    return (name && AUTHOR_IMAGES[name]) || DEFAULT_AUTHOR_IMAGE;
};
